import { useState, useEffect, useContext } from "react";
import api from "../services/api";
import { AuthContext } from "../context/Auth/AuthContext";

// feat_237 — carga las features permitidas del superadmin actual (sidebar dinámico).
// Super superadmin → todas; reseller → según superadminPermissions.
const useSuperadminFeatures = () => {
  const { user } = useContext(AuthContext);
  const [features, setFeatures] = useState(new Set());
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!user?.isSuperAdmin) {
      setFeatures(new Set());
      setLoaded(true);
      return;
    }
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/superadmin/my-features");
        if (active) setFeatures(new Set(data.features || []));
      } catch (err) {
        /* silent — fallback: sin features */
      } finally {
        if (active) setLoaded(true);
      }
    })();
    return () => {
      active = false;
    };
  }, [user?.id, user?.isSuperAdmin, user?.whitelabelScopeId]);

  const has = (key) => features.has(key);
  return { features, has, loaded };
};

export default useSuperadminFeatures;
